export default "__VITE_ASSET__CDV_0oNp__"